import React from 'react';
import Intro from './components/intro';
import Regulation from './components/regulation';
import Reference from './components/reference';
import useMap from './hooks/useMap';
import MapContext from './hooks/MapContext';
import Loader from 'react-spinners/BounceLoader';
import color from './styles/color';
import styled from 'styled-components';
import Layout from './components/layout';
import Vote from './components/vote';

const LoadContainer = styled.div`
  width: 100vw;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
`;

const PlasticStory = () => {
  const maphook = useMap();
  return (
    <MapContext.Provider value={maphook}>
      {maphook.fetching ? (
        <LoadContainer>
          <Loader size={innerWidth / 20} color={color.ippd} />
          <h1 style={{ marginTop: 50, color: color.ippd, fontWeight: 200 }}>
            โปรดรอสักครู่
          </h1>
        </LoadContainer>
      ) : (
        <>
          <Intro />
          <Regulation />
          <Vote />
          <Reference />
          </>
      )}
    </MapContext.Provider>
  );
};

export default PlasticStory;
